<template>
  <v-dialog v-model="showDialog" width="360">
    <modal-card @close="showDialog = false" full :title="title">
      <div class="pt-5 pb-6">
        <p>Mute/unmute volume for selected participants</p>
        <v-btn-toggle rounded>
          <v-btn
            v-for="(button, idx) in buttons"
            :key="idx"
            :value="button.value"
            :class="{ 'appMain--text': isActive(button.value) }"
            @click="handleMuteChange(button.value)"
          >
            <v-icon
              class="mr-2"
              :color="isActive(button.value) ? 'appMain' : 'main'"
            >
              {{ button.icon }}
            </v-icon>
            {{ button.text }}
          </v-btn>
        </v-btn-toggle>
      </div>
    </modal-card>
  </v-dialog>
</template>

<script>
import GenericAction from './GenericAction';

export default {
  name: 'ActionControlVolume',
  mixins: [GenericAction],
  data() {
    return {
      mute: '',
      showDialog: false,
      title: 'Control Volume',
      buttons: [
        {
          text: 'Unmute',
          value: false,
          icon: 'volume_up',
        },
        {
          text: 'Mute',
          value: true,
          icon: 'volume_off',
        },
      ],
    };
  },
  methods: {
    isActive(val) {
      return this.mute === val;
    },

    handleMuteChange(val) {
      this.mute = val;

      let participants = this.selectedParticipants;

      if (!participants.length) {
        participants = this.includedParticipants(this.group);
      }

      participants.forEach((part) => {
        this.api.updateParticipantInfo(
          {
            identity: part.identity,
            muted: val,
          },
          { to: 'host' }
        );
      });

      this.showDialog = false;
    },

    selected() {
      this.showDialog = true;
    },
  },
};
</script>
